import React, { Component } from 'react';
import { GoogleMap, Polygon, withGoogleMap } from 'react-google-maps';

class GeofenceMap extends Component {
    constructor(props) {
        super(props);
        this.mapRef = React.createRef();
        this.hasFitBounds = false;
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.activeGeofence) !== JSON.stringify(this.props.activeGeofence)) {
            this.hasFitBounds = false;
            this.fitMapToPolygon();
        }
    }

    fitMapToPolygon = () => {
        const { activeGeofence } = this.props;
        if (activeGeofence && activeGeofence.length > 0 && this.mapRef.current && !this.hasFitBounds) {
            const bounds = new window.google.maps.LatLngBounds();
            activeGeofence.forEach(coord => {
                bounds.extend(new window.google.maps.LatLng(Number(coord.lat), Number(coord.lng)));
            });
            this.mapRef.current.fitBounds(bounds);
            this.hasFitBounds = true;
        }
    };

    render() {
        const { activeGeofence } = this.props;

        let activePolygonPaths = null;
        if (activeGeofence && activeGeofence.length > 0) {
            activePolygonPaths = activeGeofence.map(coord => ({
                lat: Number(coord.lat),
                lng: Number(coord.lng),
            }));
        }

        const defaultCenter = this.props.center || { lat: 48.2082, lng: 16.3738 };
        const defaultZoom = this.props.zoom || 10;

        return (
            <div>
                <GoogleMap
                    ref={this.mapRef}
                    defaultZoom={defaultZoom}
                    defaultCenter={defaultCenter}
                    onTilesLoaded={this.fitMapToPolygon}>
                    {activePolygonPaths && (
                        <Polygon
                            paths={activePolygonPaths}
                            options={{
                                fillColor: '#dc3545',
                                fillOpacity: 0.35,
                                strokeColor: '#dc3545',
                                strokeOpacity: 0.8,
                                strokeWeight: 3,
                                clickable: false,
                                editable: false,
                                zIndex: 999,
                            }}
                        />
                    )}
                </GoogleMap>
            </div>
        );
    }
}

export default withGoogleMap(GeofenceMap);
